import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_3 = {
    key: 0,
    class: "row"
};
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-md-6" };
const _hoisted_6 = { class: "form-group mb-15" };
const _hoisted_7 = { class: "col-md-6" };
const _hoisted_8 = { class: "form-group mb-15" };
const _hoisted_9 = {
    key: 0,
    class: "row mt-30"
};
const _hoisted_10 = { class: "col-md-6" };
const _hoisted_11 = { class: "form-group mb-15" };
const _hoisted_12 = { class: "col-md-6" };
const _hoisted_13 = { class: "form-group mb-15" };
const _hoisted_14 = { class: "input-group" };
const _hoisted_15 = { class: "row mt-30" };
const _hoisted_16 = { class: "col-md-6" };
const _hoisted_17 = { class: "form-group mb-15" };
const _hoisted_18 = { class: "col-md-6" };
const _hoisted_19 = { class: "form-group mb-15" };
const _hoisted_20 = { class: "d-flex justify-content-end mt-25" };
const _hoisted_21 = ["disabled"];
const _hoisted_22 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_23 = {
    key: 1,
    class: "ph ph-check-circle me-2 fs-18"
};
const _hoisted_24 = { class: "restaurants-management" };
const _hoisted_25 = { class: "table-responsive" };
const _hoisted_26 = { class: "table table-hover align-middle" };
const _hoisted_27 = { class: "bg-light" };
const _hoisted_28 = {
    key: 0,
    class: "text-center"
};
const _hoisted_29 = { class: "ps-3 fw-semibold" };
const _hoisted_30 = { class: "text-center" };
const _hoisted_31 = { class: "form-check form-switch d-inline-block" };
const _hoisted_32 = ["onUpdate:modelValue", "onChange"];
const _hoisted_33 = {
    key: 0,
    class: "text-center"
};
const _hoisted_34 = { class: "form-check form-switch d-inline-block" };
const _hoisted_35 = ["onUpdate:modelValue", "onChange"];
const _hoisted_36 = { class: "text-end pe-3" };
const _hoisted_37 = {
    key: 0,
    class: "badge bg-success"
};
const _hoisted_38 = {
    key: 1,
    class: "badge bg-danger"
};
const _hoisted_39 = {
    key: 2,
    class: "text-muted small ms-2"
};
const _hoisted_40 = {
    key: 3,
    class: "text-muted small ms-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "d-flex align-items-center justify-content-between mb-15" }, [
                _createElementVNode("h5", { class: "card-title fw-bold mb-0 text-primary" }, " 🚀 Stratégie Fidélité Franchise ")
            ], -1)),
            _cache[30] || (_cache[30] = _createElementVNode("p", { class: "text-muted small mb-20" }, " Configurez les récompenses globales et gérez les droits de vos établissements. Ces paramètres s'appliquent par défaut à tous les restaurants. ", -1)),
            (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("div", { class: "col-12 text-center py-5" }, [
                            _createElementVNode("div", {
                                class: "spinner-border text-primary",
                                role: "status"
                            })
                        ], -1)
                    ]))]))
                : (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    onSubmit: _cache[7] || (_cache[7] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.saveLoyalty && _ctx.saveLoyalty(...args)), ["prevent"]))
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Mode de fidélité", -1)),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.loyalty_mode) = $event)),
                                    class: "form-select shadow-none fw-semibold rounded-0",
                                    onChange: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleModeChange && _ctx.handleModeChange(...args)))
                                }, [...(_cache[9] || (_cache[9] = [
                                        _createElementVNode("option", { value: "CLASSIC" }, "Classic (1CHF = 1pt)", -1),
                                        _createElementVNode("option", { value: "MCDO" }, "Va Bene (Paliers & Produits)", -1)
                                    ]))], 544), [
                                    [_vModelSelect, _ctx.loyalty_mode]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom du programme", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "e.g. MyVabene Rewards",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.loyalty_name) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.loyalty_name]
                                ])
                            ])
                        ])
                    ]),
                    (_ctx.loyalty_mode === 'MCDO')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-md-12" }, [
                                _createElementVNode("h6", { class: "text-black fw-bold mb-20 text-uppercase letter-spacing" }, "🍕 Configuration Spécifique"),
                                _createElementVNode("p", { class: "text-muted small mb-20" }, " Définissez le comportement global de vos récompenses produits. Ces réglages s'appliqueront par défaut aux futures récompenses. ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Portée par défaut des récompenses", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.loyalty_product_scope) = $event)),
                                        class: "form-select shadow-none fw-semibold rounded-0"
                                    }, [...(_cache[12] || (_cache[12] = [
                                            _createElementVNode("option", { value: "GLOBAL" }, "GLOBAL (Partagé entre restaurants)", -1),
                                            _createElementVNode("option", { value: "LOCAL" }, "LOCAL (Propre à chaque restaurant)", -1)
                                        ]))], 512), [
                                        [_vModelSelect, _ctx.loyalty_product_scope]
                                    ]),
                                    _cache[14] || (_cache[14] = _createElementVNode("small", { class: "text-muted" }, [
                                        _createElementVNode("strong", null, "GLOBAL"),
                                        _createTextVNode(" : La récompense reste au panier même si le client change de restaurant."),
                                        _createElementVNode("br"),
                                        _createElementVNode("strong", null, "LOCAL"),
                                        _createTextVNode(" : La récompense est vidée du panier en cas de changement de restaurant. ")
                                    ], -1))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Durée du Timer par défaut", -1)),
                                    _createElementVNode("div", _hoisted_14, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            placeholder: "3600",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.loyalty_product_expiry_duration) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.loyalty_product_expiry_duration]
                                        ]),
                                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "input-group-text" }, "secondes", -1))
                                    ]),
                                    _cache[17] || (_cache[17] = _createElementVNode("small", { class: "text-muted" }, "Défaut: 3600 sec (1 heure). Temps alloué pour passer commande après activation.", -1))
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-md-12" }, [
                            _createElementVNode("h6", { class: "text-black fw-bold mb-20 text-uppercase letter-spacing" }, "🤝 Configuration du Parrainage"),
                            _createElementVNode("p", { class: "text-muted small mb-20" }, " Définissez les points de bienvenue offerts aux nouveaux clients et les récompenses pour les parrains. Ces valeurs s'appliquent à tous les restaurants de la franchise par défaut. ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Points de bienvenue (Filleul)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "ex: 1000",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.referralPointsReferee) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.referralPointsReferee]
                                ]),
                                _cache[20] || (_cache[20] = _createElementVNode("small", { class: "text-muted" }, "Points reçus par le nouvel utilisateur dès son inscription via un code.", -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Points offerts au Parrain", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "ex: 500",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.referralPointsReferrer) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.referralPointsReferrer]
                                ]),
                                _cache[22] || (_cache[22] = _createElementVNode("small", { class: "text-muted" }, "Points reçus par le parrain lors du premier achat validé de son filleul.", -1))
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("button", {
                            type: "submit",
                            class: "btn btn-primary text-white px-5 py-2 fw-bold rounded-2 shadow-sm",
                            disabled: _ctx.isSaving
                        }, [
                            (_ctx.isSaving)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                                : (_openBlock(), _createElementBlock("i", _hoisted_23)),
                            _cache[24] || (_cache[24] = _createTextVNode(" Enregistrer la Stratégie Franchise ", -1))
                        ], 8, _hoisted_21)
                    ])
                ], 32)),
            _cache[31] || (_cache[31] = _createElementVNode("hr", { class: "my-40" }, null, -1)),
            _createElementVNode("div", _hoisted_24, [
                _cache[28] || (_cache[28] = _createElementVNode("h6", { class: "text-black fw-bold mb-20 text-uppercase letter-spacing" }, "Gestion des Établissements", -1)),
                _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("table", _hoisted_26, [
                        _createElementVNode("thead", _hoisted_27, [
                            _createElementVNode("tr", null, [
                                _cache[25] || (_cache[25] = _createElementVNode("th", { class: "ps-3" }, "Restaurant", -1)),
                                _cache[26] || (_cache[26] = _createElementVNode("th", { class: "text-center" }, "Fidélité Activée", -1)),
                                (_ctx.loyalty_mode !== 'MCDO')
                                    ? (_openBlock(), _createElementBlock("th", _hoisted_28, "Personnalisation Locale"))
                                    : _createCommentVNode("", true),
                                _cache[27] || (_cache[27] = _createElementVNode("th", { class: "text-end pe-3" }, "Status", -1))
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allRestaurants, (res) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: res.id
                                }, [
                                    _createElementVNode("td", _hoisted_29, _toDisplayString(res.name), 1),
                                    _createElementVNode("td", _hoisted_30, [
                                        _createElementVNode("div", _hoisted_31, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                "onUpdate:modelValue": ($event) => ((res.enableLoyalty) = $event),
                                                onChange: ($event) => (_ctx.updateResOption(res))
                                            }, null, 40, _hoisted_32), [
                                                [_vModelCheckbox, res.enableLoyalty]
                                            ])
                                        ])
                                    ]),
                                    (_ctx.loyalty_mode !== 'MCDO')
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
                                            _createElementVNode("div", _hoisted_34, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": ($event) => ((res.allowLoyaltyCustomization) = $event),
                                                    onChange: ($event) => (_ctx.updateResOption(res))
                                                }, null, 40, _hoisted_35), [
                                                    [_vModelCheckbox, res.allowLoyaltyCustomization]
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("td", _hoisted_36, [
                                        (res.enableLoyalty)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_37, "ACTIF"))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_38, "INACTIF")),
                                        (_ctx.loyalty_mode === 'MCDO' || !res.allowLoyaltyCustomization)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Suit la stratégie"))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_40, "Personnalisé"))
                                    ])
                                ]));
                            }), 128))
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
